import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { DegreeObjective } from '../../models/application/degree-objective.interface';
import { Observable, ReplaySubject } from 'rxjs';
import { first, flatMap } from 'rxjs/operators';

@Injectable({ providedIn: 'root' })
export class DegreeObjectiveService {
	$degreeObjectiveData: Observable<DegreeObjective>;
	$degreeObjectivesData: Observable<Array<DegreeObjective>>;
	readonly degreeObjectiveDataSubject: ReplaySubject<DegreeObjective>;
	readonly degreeObjectivesDataSubject: ReplaySubject<Array<DegreeObjective>>;

	constructor(private readonly http: HttpClient) {
		this.degreeObjectiveDataSubject = new ReplaySubject<DegreeObjective>(
			undefined
		);
		this.degreeObjectivesDataSubject = new ReplaySubject<
			Array<DegreeObjective>
		>(undefined);
		this.$degreeObjectiveData = this.degreeObjectiveDataSubject.asObservable();
		this.$degreeObjectivesData =
			this.degreeObjectivesDataSubject.asObservable();
	}

	getProgramDegreeObjectives(
		programId: number
	): Observable<Array<DegreeObjective>> {
		return this.http.get<Array<DegreeObjective>>(
			`programs/${programId.toString()}/degree-objectives`
		);
	}

	getApplicationDegreeObjective(
		applicationId: number
	): Observable<DegreeObjective> {
		return this.http
			.get<
				Array<DegreeObjective>
			>(`applications/${applicationId.toString()}/degree-objectives`)
			.pipe(
				flatMap((e) => e),
				first()
			);
	}

	updateApplicationDegreeObjective(
		applicationId: number,
		degreeObjective: DegreeObjective
	): Observable<DegreeObjective> {
		return this.http.put<DegreeObjective>(
			`applications/${applicationId.toString()}/degree-objectives/${degreeObjective.id}`,
			degreeObjective
		);
	}

	updateDegreeObjectiveSubject(degreeObjective: DegreeObjective): void {
		this.degreeObjectiveDataSubject.next(degreeObjective);
	}

	updateDegreesObjectiveSubject(
		degreeObjectives: Array<DegreeObjective>
	): void {
		this.degreeObjectivesDataSubject.next(degreeObjectives);
	}

	getDegreeObjectives(): Observable<Array<DegreeObjective>> {
		return this.http.get<Array<DegreeObjective>>(`degree-types`);
	}

	getDegreeObjectivesByProgramId(programId: number): Observable<Array<DegreeObjective>> {
		return this.http.get<Array<DegreeObjective>>(`programs/${programId.toString()}/degree-objectives`);
	}
}
